import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggedUser, LoggedUserSuccess } from './action';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/providers/auth/auth.service';
import { UserDetails } from 'src/app/shared/models/auth/user';

@Injectable()

export class AuthEffect {

    constructor(private actions$: Actions, private auth: AuthService){

    }

    LoadUser$ =  createEffect(() =>
        this.actions$.pipe(
            ofType(LoggedUser),
            mergeMap(() =>
                this.auth.getLoggedData().pipe(
                    map((userData: UserDetails[]) => LoggedUserSuccess({user: userData}))
                )
            )
        )
    ); // end of effect

}// end of class


